(function () {
  function init() {
    var vid = document.querySelector('.hero .person-vid');
    if (!vid) return;
    var src = vid.getAttribute('data-vid-src');
    if (!src || vid.src) return;
    vid.setAttribute('preload', 'metadata');
    vid.src = src;
    var p = vid.play();
    if (p && p.catch) p.catch(function(){});
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
